var map = {
	"./fig01.jpg": "1d11",
	"./fig02.jpg": "28d6",
	"./fig03.jpg": "0855",
	"./fig04.jpg": "7aad",
	"./fig05.jpg": "b51c",
	"./fig06.jpg": "ce3a",
	"./fig07.jpg": "086d",
	"./fig08.jpg": "7a0c",
	"./fig09.jpg": "3da4",
	"./fig10.jpg": "b8b5",
	"./fig11.jpg": "51e5",
	"./fig12.jpg": "29cb",
	"./fig13.jpg": "0dd6",
	"./fig14.jpg": "afa6",
	"./fig15.jpg": "8a0b",
	"./fig16.jpg": "8245"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b0a";